import type { PropsOf } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, Text, tokens } from '@hotjar/hotsauce';
import type { User } from '@hotjar/navigation/src/types';

export type ProfileSummaryProps = {
  avatar: User['avatar'];
  email: User['email'];
  name: User['name'];
  /**
   * This event handler is just for tracking whether users expect to click their avatar or
   * profile summary in the account dropdown menu, it is not for any real actions.
   */
  onClick?: PropsOf<'div'>['onClick'];
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${tokens.spacer.x2pt5} ${tokens.spacer.x1pt5} ${tokens.spacer.x1pt5};
  background: ${tokens.BRAND_COLORS.cobalt_100};
  border-bottom: 1px solid ${tokens.color.neutral_100};
`;

const StyledAvatar = styled(Avatar)`
  width: 64px;
  height: 64px;

  > span {
    font-size: 32px;
  }
`;

const CopyBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${tokens.spacer.x1pt5};
`;

export const ProfileSummary = ({
  avatar,
  email,
  name,
  onClick,
}: ProfileSummaryProps): JSX.Element => (
  <Container onClick={onClick}>
    {/*TODO: change this size to match the design (64px) once available in DS*/}
    {/* FIXME: [CUX-58] shouldn't have to assert type of avatarUrl as it should accept undefined */}
    {/* @ts-expect-error avatarUrl should accept undefined */}
    <StyledAvatar size="xl" userName={name} src={avatar || undefined} altText={name} />
    <CopyBlock>
      <Text textType="subtitle1" textColor="text_default">
        {name}
      </Text>
      {email && (
        <Text textType="caption" textColor="text_light">
          {email}
        </Text>
      )}
    </CopyBlock>
  </Container>
);
